// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8112f29c","453":"aae0430f","732":"d364b472"}[chunkId] + ".chunk.js";
};